import styled from '@emotion/styled'
import React, { memo } from 'react'
import { useInView } from 'react-intersection-observer'

export interface Props {
  isSticky?: boolean
  onClick?: () => void
}

export const Hamburger = memo(function Hamburger({ isSticky, onClick }: Props) {
  const [animObjectRef, isAnimObjectVisible] = useInView({
    triggerOnce: true,
  })

  return (
    <Container
      className={`${isSticky ? 'is-sticky' : ''}${
        isAnimObjectVisible ? ' visible' : ''
      }`}
      onClick={onClick}
      ref={animObjectRef}
    >
      <Line />
      <Line />
      <Line />
    </Container>
  )
})

const Container = styled.div`
  width: 4.5rem;
  height: 4.5rem;
  background: ${({ theme }) => theme.colors.variants.primaryDark};
  cursor: pointer;
  opacity: 0;
  transform: translateY(-2.5rem);
  transition: 1s 1.5s ease-in-out;
  position: relative;
  &:hover {
    > div {
      &:nth-of-type(1) {
        left: 50%;
      }
      &:nth-of-type(3) {
        right: 50%;
      }
    }
  }
  &.is-sticky {
    opacity: 1 !important;
    transform: none !important;
  }
  &.visible {
    opacity: 1;
    transform: none;
  }

  @media (max-width: 1199px) {
    width: 3.75rem;
    height: 3.75rem;
    opacity: 1;
    transform: none;
  }
`

const Line = styled.div`
  height: 0.0625rem;
  background: ${({ theme }) => theme.colors.variants.neutralLight5};
  position: absolute;
  right: 1.3125rem;
  left: 1.3125rem;
  transition: 0.6s cubic-bezier(0, 0.55, 0.45, 1);
  &:nth-of-type(1) {
    top: 2.0625rem;
  }
  &:nth-of-type(2) {
    top: 2.25rem;
  }
  &:nth-of-type(3) {
    top: 2.4375rem;
  }

  @media (max-width: 1199px) {
    right: 0.9375rem;
    left: 0.9375rem;
    &:nth-of-type(1) {
      top: 1.5625rem;
    }
    &:nth-of-type(2) {
      top: 1.875rem;
    }
    &:nth-of-type(3) {
      top: 2.1875rem;
    }
  }
`
